import React from 'react';
import { motion, Variants } from 'framer-motion';
import ScrambleText from '../effects/ScrambleText';

const containerVariants: Variants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.3,
      delayChildren: 0.5,
    },
  },
};

const itemVariants: Variants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 1.2, ease: [0.16, 1, 0.3, 1] }, // A more refined ease
  },
};

const Hero: React.FC = () => {
  const roles = [
    'AI Engineer',
    'Creative Developer',
    'Machine Learning',
    'Three.js Artist',
    'Game Developer',
  ];

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <motion.div
        className="relative z-10 max-w-5xl mx-auto px-4 text-center"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        <motion.h1
          variants={itemVariants}
          className="text-6xl md:text-8xl lg:text-9xl font-bold text-[var(--color-foreground)] mb-6 font-display tracking-tighter"
        >
          Tornado guy
        </motion.h1>

        <motion.div
          variants={itemVariants}
          className="text-lg md:text-xl font-normal mb-8 h-10 flex items-center justify-center text-[var(--color-muted)]"
        >
          <ScrambleText
            texts={roles}
            scrambleDuration={1200}
            displayDuration={3000}
            pauseDuration={800}
          />
        </motion.div>

        <motion.p
          variants={itemVariants}
          className="text-[var(--color-foreground)] text-base md:text-lg max-w-2xl mx-auto leading-relaxed opacity-80"
        >
        </motion.p>
      </motion.div>
    </section>
  );
};

export default Hero;